import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdminBadgeComponent } from './badge.component';

@NgModule({
  declarations: [AdminBadgeComponent],
  imports: [CommonModule],
  exports: [AdminBadgeComponent],
})
export class AdminBadgeModule {}
